import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=80b9361e&"
import script from "./notifications.vue?vue&type=script&lang=ts&"
export * from "./notifications.vue?vue&type=script&lang=ts&"
import style0 from "./notifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports